import {SearchIcon} from "../props";
import magnifier from "../../../../icons/maginifier-white.svg";
import React from "react";

export const TypeAheadSearchMagnifier = ({display, doSearch}: SearchIcon) => {
  if (!display) {
    return null;
  }
  return (
    <button className="typeahead-search__button" onClick={doSearch}>
      <img
        src={magnifier}
        alt="magnifier"
        className="typeahead-search__magnifier"
      />
    </button>
  )
};
